module.exports = __webpack_public_path__ + "static/media/whoWeAre3.ddb1fee4.jpg";